import { computed } from 'mobx';

export default class DataOriginModel {
  id;
  store;
  keys = ['id', 'name', 'code', 'timezone', 'installed', 'data_origin_parameters', 'block'];

  constructor(store, dataOrigin) {
    this.store = store;
    this.id = +dataOrigin.id;
    this.code = dataOrigin.code;
    this.timezone = dataOrigin.timezone;
    this.block = dataOrigin.block;
    this.installed = dataOrigin.installed;
    this.stations = (dataOrigin.stations && dataOrigin.stations.map(station => (
      this.store.stationStore.resolveItem(station)
    ))) || [];
    this.data_origin_parameters = dataOrigin.data_origin_parameters;
  }

  @computed get asJson() {
    return {
      id: +this.id,
      name: this.name,
      code: this.code,
      timezone: this.timezone,
      block: this.block,
      installed: this.installed,
      stations: this.stations,
      data_origin_parameters: this.data_origin_parameters,
    };
  }

  updateFromJson(json) {
    this.keys.forEach(key => {
      if(json[key] || json[key] === 0){
        this[key] = json[key];
      }
    })
    // this.id = +json.id;
    // this.name = json.name;
    // this.code = json.code;
    // this.timezone = json.timezone;
    // this.installed = json.installed;
    // this.data_origin_parameters = json.data_origin_parameters;
  }
}



// WEBPACK FOOTER //
// ./src/models/DataOriginModel.js